import { __assign } from "tslib";
// DS: i2.3
import React from 'react';
import IconWrap from '../../IconWrap';
var GalleryGrid = function (props) {
    return (React.createElement(IconWrap, __assign({}, props),
        React.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg" },
            React.createElement("path", { d: "M0 1v6a1 1 0 001 1h6a1 1 0 001-1V1a1 1 0 00-1-1H1a1 1 0 00-1 1zm10 0v6a1 1 0 001 1h6a1 1 0 001-1V1a1 1 0 00-1-1h-6a1 1 0 00-1 1zM0 11v6a1 1 0 001 1h6a1 1 0 001-1v-6a1 1 0 00-1-1H1a1 1 0 00-1 1zm10 0v6a1 1 0 001 1h6a1 1 0 001-1v-6a1 1 0 00-1-1h-6a1 1 0 00-1 1z", transform: "translate(3 3)" }))));
};
GalleryGrid.displayName = 'GalleryGrid';
export default GalleryGrid;
//# sourceMappingURL=GalleryGrid.js.map